export enum AttachedOrganization {
  CAF = 'CAF',
  MSA = 'MSA',
}
export const labelsByOrganization: Map<AttachedOrganization, string> = new Map<AttachedOrganization, string>(
  Object.keys(AttachedOrganization).map((x: string) => [x, AttachedOrganization[x]] as [AttachedOrganization, string]),
);
